import { supabase } from "@/lib/supabase";

/**
 * Marque les rappels des 7 derniers jours comme convertis.
 * Un échec de suivi ne doit jamais annuler la modification de flotte.
 */
export const trackOwnerFleetReminderUpdate = async (ownerId?: string): Promise<void> => {
  try {
    const rpc = supabase.rpc;
    if (typeof rpc !== "function") return;

    let resolvedOwnerId = ownerId;
    if (!resolvedOwnerId) {
      const getUser = supabase.auth?.getUser;
      if (typeof getUser !== "function") return;
      const { data } = await getUser();
      resolvedOwnerId = data.user?.id;
    }
    if (!resolvedOwnerId) return;

    await rpc("track_fleet_reminder_update", { p_owner_id: resolvedOwnerId });
  } catch {
    // Le suivi opérationnel reste secondaire par rapport à l'enregistrement véhicule.
  }
};
